<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 mb-4">
        <template v-if="oldEvaluationWorks && oldEvaluationWorks.data && oldEvaluationWorks.data.length > 0">
          <div class="mb-4">
            <div class="section-header font-weight-bold old-evaluation-works-collapse" v-b-toggle.old-evaluation-works>
              <h4>
                <i class="fa fa-arrow-down"></i>
                Олдин бахоланганлар
                <span class="badge badge-warning d-inline-flex align-items-center justify-content-center m-1">{{ oldEvaluationWorks.data.length }}</span>
              </h4>
            </div>
            <b-collapse id="old-evaluation-works" accordion="old-evaluation-works" role="tabpanel">
              <div class="row">
                <div class="col-12 col-md-6 col-xl-4" v-for="oldWork in oldEvaluationWorks.data" :key="'work_' + oldWork.id">
                  <div class="alert alert-secondary alert-dismissible fade show alert-wrap" role="alert">
                    <a class="alert-heading" :href="oldWork.url + `/new-real-estate/edit/${oldWork.id}`" target="_blank">#{{oldWork.id}}  {{oldWork.name}}</a>
                    <p class="font-weight-bold pl-3 mt-1">{{oldWork.total | currency('', 2, { thousandsSeparator: ' ' })}} сўм</p>
                    <p class="alert-item mb-0"> Бахоланган сана
                      <span v-if="oldWork.confirmedDate">{{oldWork.confirmedDate}} </span>
                      <span v-else>{{new Date(oldWork.createdDate) | dateFormat('DD/MM/YYYY hh:mm')}}</span>
                    </p>
                    <p class="alert-item mb-0">Бахолаш мақсади <span class="badge badge-pill badge-warning" v-if="oldWork.evlGoalTypeDto">{{oldWork.evlGoalTypeDto.typeName}} </span></p>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </template>
      </div>
      <div class="col-12">
        <div class="card card-form">
          <div class="card-header">
            <div class="row">
              <div class="col">
                <div class="pull-left">
                  <h4 class="card-title float-left">
                    {{ $t("auto.plus.list") }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <div class="form-group">
                        <label>{{ $t("auto.technicalConditionOfCar") }} <span class="red">*</span></label>
                        <select class="form-control"
                                v-model="auto.appraisalAutoDto.technicalConditionOfCar"
                                :class="{invalid : $v.auto.appraisalAutoDto.technicalConditionOfCar.$error}"
                                @change="onChangeTechnicalCondition">
                          <option value=""></option>
                          <option :value="option.key"
                                  v-for="option in technicalConditionOfCars"
                                  :key="option.key">
                            {{ option.name }}
                          </option>
                        </select>
                        <div class="red"
                             v-if="$v.auto.appraisalAutoDto.technicalConditionOfCar.$error">
                          {{ $t("auto.technicalConditionOfCar") }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.evaluator") }} <span class="red">*</span></label>
                      <v-select v-model="auto.employee" label="text"
                                :options="employees"
                                :filterable="false"
                                @search="onEmployeeSearch"
                                @search:focus="onEmployeeFocus"
                                @change="onChangeEmployee"
                                :class="{invalid : $v.auto.employee.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.text"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="auto && auto.employee && auto.employee.text">
                          <div v-html="auto.employee.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                      <div class="red" v-if="$v.auto.employee.$error">
                        {{ $t("realEstate.validation.evaluator") }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.ownerClient") }} <span class="red">*</span></label>
                      <v-select v-model="auto.ownerClient" label="text"
                                :options="owners"
                                :filterable="false"
                                @search="onOwnerSearch"
                                @search:focus="onOwnerFocus"
                                :class="{invalid : $v.auto.ownerClient.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.text"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="auto && auto.ownerClient && auto.ownerClient.text">
                          <div v-html="auto.ownerClient.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                      <div class="red" v-if="$v.auto.ownerClient.$error">
                        {{ $t("realEstate.validation.ownerClient") }}
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="form-check pl-0">
                        <label class="form-check-label" style="padding-left:22px !important">
                          <input class="form-check-input" type="checkbox"
                                 v-model="auto.hasCustomerClient">
                          <span class="form-check-sign"></span>
                          {{ $t("realEstate.field.withLetterOfAttorney") }}
                        </label>
                      </div>
                    </div>
                    <div class="form-group" v-if="auto.hasCustomerClient">
                      <label>Буйюртмачи <span
                          class="red">*</span></label>
                      <v-select v-model="auto.customerClient" label="text"
                                :options="customers"
                                :filterable="false"
                                @search="onCustomerSearch"
                                @search:focus="onCustomerFocus"
                                :class="{invalid : $v.auto.customerClient.$error}">
                        <template slot="option" slot-scope="option" v-if="option && option.text">
                          <div v-html="option.text"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="auto && auto.customerClient && auto.customerClient.text">
                          <div v-html="auto.customerClient.text"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                      <div class="red" v-if="$v.auto.customerClient.$error">
                        Буйюртмачи
                      </div>
                    </div>

                    <div class="form-group" v-if="auto.hasCustomerClient">
                      <label>Ишончнома номери: <span class="red">*</span></label>
                      <input type="text" class="form-control" v-model="auto.powerOfAttorneyNumber"
                             :class="{invalid : $v.auto.powerOfAttorneyNumber.$error}"/>
                      <div class="red" v-if="$v.auto.powerOfAttorneyNumber.$error">Ишончнома номери
                      </div>
                    </div>

                    <div class="form-group" v-if="auto.hasCustomerClient">
                      <label>Ишончнома санаси: <span class="red">*</span></label>
                      <datepicker class="form-control" format="dd/MM/yyyy"
                                  v-model="powerOfAttorneyDate"
                                  :clear-button="true"
                                  :class="{invalid : $v.powerOfAttorneyDate.$error}"></datepicker>
                      <div class="red" v-if="$v.powerOfAttorneyDate.$error">Ишончнома санаси:
                      </div>
                    </div>


                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{ $t("auto.dilapidationValueByExpert") }} <span
                          class="red">*</span></label>
                      <select class="form-control"
                              v-model="auto.appraisalAutoDto.dilapidationValueByExpert"
                              :class="{invalid : $v.auto.appraisalAutoDto.dilapidationValueByExpert.$error}">
                        <option value=""></option>
                        <option :value="option.key" v-for="option in dilapidationLookupData"
                                :key="option.key">
                          {{ option.name }}
                        </option>
                      </select>
                      <div class="red"
                           v-if="$v.auto.appraisalAutoDto.dilapidationValueByExpert.$error">
                        {{ $t("auto.dilapidationValueByExpert") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.evaluatorIdea") }}</label>
                      <textarea type="text" class="form-control"
                                v-model="auto.evaluatorIdea"></textarea>
                    </div>
                    <div class="form-group">
                      <label>Чекловчи шартлар</label>
                      <textarea type="text" class="form-control"
                                v-model="auto.evaluatorRestrictiveTerms"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                      v-model="selectedRealEstateDocsTab"
                      :options="[
                                { text: 'Автотранспорт расмлари', value: 'images' },
                                { text: 'Хужжатлар', value: 'docs' } ]"
                      :aria-describedby="ariaDescribedby"
                      button-variant="form-radio-group"
                      name="radio-btn-outline1"
                      buttons
                  ></b-form-radio-group>
                </b-form-group>

                <div v-if="selectedRealEstateDocsTab === 'images'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in autoAllPhotos" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <!--<img :src="photo.filePath" width="100%" style="height: 500px;" :style="rotateStyle" />-->
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>

                <div v-if="selectedRealEstateDocsTab === 'docs'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in texPassportAllPhotos" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <!--<img :src="photo.filePath" width="100%" style="height: 500px;" :style="rotateStyle" />-->
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>
              </div>
            </div>
            <div class="row" v-if="showReportButton">
              <div class="col-12 btns-box">
                <button
                    class="all-btn pull-right btn-sm"
                    v-if="hasPermission('NEW_AUTO_REPORT_WORD_QR_CODE')"
                    @click="reportDocQrCode(auto)">
                  <i v-if="loading.isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleWordQrCode") }}
                </button>
                <button
                    class="all-btn pull-right btn-sm"
                    v-if="hasPermission('NEW_AUTO_REPORT_WORD')"
                    @click="reportDoc(auto)">
                  <i v-if="loading.isDocLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleWord") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_AUTO_REPORT_PDF_QR_CODE')"
                        @click="reportPdfQrCode(auto)">
                  <i v-if="loading.isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleQrCode") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_AUTO_REPORT_PDF')"
                        @click="reportPdf(auto)">
                  <i v-if="loading.isPdfLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.title") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_AUTO_CONTRACT_PDF_QR_CODE')"
                        @click="contractQrCodePdf(auto)">
                  <i v-if="loading.isCPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractPdfQrCode") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_AUTO_CONTRACT_PDF')"
                        @click="contractPdf(auto)">
                  <i v-if="loading.isCPdfLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractPdf") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_AUTO_CONTRACT_WORD_QR_CODE')"
                        @click="contractDocQrCode(auto)">
                  <i v-if="loading.isCDocQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractWordQrCode") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_AUTO_CONTRACT_WORD')"
                        @click="contractDoc(auto)">
                  <i v-if="loading.isCDocLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractWord") }}
                </button>
                <button class="btn btn-primary pull-right mr-2 btn-sm"
                        v-if="hasPermission('NEW_AUTO_REPORT_PDF_NOT_SIGNED_AND_QRCODE')"
                        @click="notSignedAndQRCodeReportPdf(auto)">
                  <i v-if="loading.isPdfNotSignedAndQRCodeLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.title") }}
                </button>
                <button
                    class="btn btn-primary pull-right mr-2 btn-sm"
                    v-if="hasPermission('NEW_AUTO_REPORT_WORD_NOT_SIGNED_AND_QRCODE')"
                    @click="notSignedAndQRCodeReportDoc(auto)">
                  <i v-if="loading.isDocNotSignedAndQRCodeLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleWord") }}
                </button>
              </div>
            </div>

            <div role="tablist">
              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.header-1 v-tooltip="'Автотранспорт маълумотлари'">
                      <h4>
                        <i class="fa fa-arrow-down"></i>
                        {{ $t("auto.plus.autoInformationVisible") }}
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="header-1" accordion="evl-accordion" role="tabpanel"
                              v-model="autoInformationVisible">
                    <div class="row">
                      <div class="col-12">
                        <button class="all-btn add-btn pull-right" @click="saveAuto">
                          {{ $t("action.save") }}
                        </button>
                      </div>
                      <div class="col-12 col-lg-4 col-md-6">
                        <div class="form-group">
                          <label>{{ $t("auto.selectAuto") }} <span class="red">*</span></label>
                          <v-select v-model="auto.appraisalAutoDto.autoTypeDto"
                                    label="fullName"
                                    :options="autoTypeDtos"
                                    :filterable="false"
                                    @search="onAutoTypeSearch"
                                    @search:focus="onAutoTypeFocus"
                                    :class="{invalid : $v.auto.appraisalAutoDto.autoTypeDto.$error}">
                            <template slot="option" slot-scope="option" v-if="option">
                              <div v-html="option.text"></div>
                            </template>
                            <template slot="selected-option"
                                      v-if="auto.appraisalAutoDto.autoTypeDto && auto.appraisalAutoDto.autoTypeDto.text">
                              <div v-html="auto.appraisalAutoDto.autoTypeDto.text"
                                   @click="$eventBus.$emit('search:focus')"></div>
                            </template>
                            <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                          </v-select>

                          <div class="red" v-if="$v.auto.appraisalAutoDto.autoTypeDto.$error">
                            {{ $t("auto.selectAuto") }}
                          </div>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.madeYear") }} <span class="red">*</span></label>
                          <numeric-input class="form-control"
                                         v-model="auto.appraisalAutoDto.madeYear"
                                         :class="{invalid : $v.auto.appraisalAutoDto.madeYear.$error}"
                                         :controls="false" :precision="0"></numeric-input>
                          <div class="red" v-if="$v.auto.appraisalAutoDto.madeYear.$error">
                            {{ $t("auto.madeYear") }}
                          </div>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.governmentNum") }} <span
                              class="red">*</span></label>
                          <input type="text" class="form-control"
                                 v-model="auto.appraisalAutoDto.governmentNum"
                                 :class="{invalid : $v.auto.appraisalAutoDto.governmentNum.$error}"/>
                          <div class="red"
                               v-if="$v.auto.appraisalAutoDto.governmentNum.$error">
                            {{ $t("auto.governmentNum") }}
                          </div>
                        </div>
                        <div class="form-group">
                          <label>{{ $t("auto.engineNum") }} </label>
                          <input type="text" class="form-control"
                                 v-model="auto.appraisalAutoDto.engineNum"/>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.bodyNum") }} </label>
                          <input type="text" class="form-control"
                                 v-model="auto.appraisalAutoDto.bodyNum"/>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.shasseNum") }} </label>
                          <input type="text" class="form-control"
                                 v-model="auto.appraisalAutoDto.shasseNum"/>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.autoColor") }} </label>
                          <input type="text" class="form-control"
                                 v-model="auto.appraisalAutoDto.autoColor"/>
                        </div>
                      </div>
                      <div class="col-12 col-lg-4 col-md-6">
                        <div class="form-group">
                          <label>{{ $t("auto.technicalConditionReport") }} </label>
                          <select class="form-control"
                                  v-model="auto.appraisalAutoDto.technicalConditionReport"
                                  @change="onChangeTechnicalConditionReport">
                            <option value=""></option>
                            <option :value="option.key"
                                    v-for="option in technicalConditions" :key="option.id">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.electricalComponents") }} </label>
                          <select class="form-control"
                                  v-model="auto.appraisalAutoDto.electricalComponents">
                            <option value=""></option>
                            <option :value="option.key" v-for="option in autoPartConditions"
                                    :key="option.key">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.steeringMechanisms") }} </label>
                          <select class="form-control"
                                  v-model="auto.appraisalAutoDto.steeringMechanisms">
                            <option value=""></option>
                            <option :value="option.key" v-for="option in autoPartConditions"
                                    :key="option.id">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.engine") }} </label>
                          <select class="form-control" v-model="auto.appraisalAutoDto.engine">
                            <option value=""></option>
                            <option :value="option.key" v-for="option in autoPartConditions"
                                    :key="option.id">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.transmissionBox") }} </label>
                          <select class="form-control"
                                  v-model="auto.appraisalAutoDto.transmissionBox">
                            <option value=""></option>
                            <option :value="option.key" v-for="option in autoPartConditions"
                                    :key="option.id">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.saloonParts") }} </label>
                          <select class="form-control"
                                  v-model="auto.appraisalAutoDto.saloonParts">
                            <option value=""></option>
                            <option :value="option.key"
                                    v-for="option in evlAutoSaloonPartConditions"
                                    :key="option.id">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.additionalConveniences") }} </label>
                          <select class="form-control"
                                  v-model="auto.appraisalAutoDto.additionalConveniences">
                            <option value=""></option>
                            <option :value="option.key"
                                    v-for="option in additionalConveniences"
                                    :key="option.key">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>

                      </div>
                      <div class="col-12 col-lg-4 col-md-6">
                        <div class="form-group">
                          <label>{{ $t("auto.fullWeight") }} </label>
                          <input type="text" class="form-control"
                                 v-model="auto.appraisalAutoDto.fullWeight"/>
                        </div>
                        <div class="form-group">
                          <label>{{ $t("auto.highWeight") }} </label>
                          <input type="text" class="form-control"
                                 v-model="auto.appraisalAutoDto.highWeight"/>
                        </div>
                        <div class="form-group">
                          <label>{{ $t("auto.texPassportNum") }} <span
                              class="red">*</span></label>
                          <input type="text" class="form-control"
                                 v-model="auto.appraisalAutoDto.texPassportNum"
                                 :class="{invalid : $v.auto.appraisalAutoDto.texPassportNum.$error}"/>
                          <div class="red"
                               v-if="$v.auto.appraisalAutoDto.texPassportNum.$error">
                            {{ $t("auto.texPassportNum") }}
                          </div>
                        </div>

                        <div class="form-group">
                          <label>{{ $t("auto.adress") }} <span class="red">*</span></label>
                          <input type="text" class="form-control"
                                 v-model="auto.appraisalAutoDto.address"
                                 :class="{invalid : $v.auto.appraisalAutoDto.address.$error}"/>
                          <div class="red" v-if="$v.auto.appraisalAutoDto.address.$error">
                            {{ $t("auto.adress") }}
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Ёқилғи тури <span class="red">*</span></label>
                          <select class="form-control"
                                  v-model="auto.appraisalAutoDto.fuelType">
                            <option :value="option.key" v-for="option in fuelTypes"
                                    :key="option.key">{{ option.name }}
                            </option>
                          </select>
                          <div class="red"
                               v-if="$v.auto.appraisalAutoDto.fuelType.$error">
                            Ёқилғи тури
                          </div>
                        </div>
                        <div class="form-group"
                             v-if="hasNotMileage">
                          <label>{{ $t("auto.overpassKm") }} <span class="red">*</span></label>
                          <numeric-input class="form-control" v-model="auto.appraisalAutoDto.overpassKm"
                                         :class="{invalid : $v.auto.appraisalAutoDto.overpassKm.$error}"
                                         :controls="false" :precision="0"></numeric-input>
                          <div class="red" v-if="$v.auto.appraisalAutoDto.overpassKm.$error">
                            {{ $t("auto.overpassKm") }}
                          </div>
                        </div>

                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.auto-comparative v-tooltip="'Қиёсий ёндашув'">
                      <h4>
                        <div class="d-flex">
                          <i class="fa fa-arrow-down"></i>
                          <input type="checkbox" class="ml-2 mr-1"
                                 v-model="auto.appraisalAutoDto.approachThree">
                          {{ $t("auto.approach.comparative") }}
                          <b class="ml-4" v-if="auto.appraisalAutoDto.approachThree">
                            <span class="text-success"
                                  v-if="autoData.kossApiResponseDto && autoData.kossApiResponseDto.govPrice">{{
                                autoData.kossApiResponseDto.govPrice | currency('', 2, {thousandsSeparator: ' '})
                              }} сўм</span>
                            <span class="text-success"
                                  v-else>{{ 0 | currency('', 2, {thousandsSeparator: ' '}) }} сўм</span>
                          </b>
                        </div>

                      </h4>
                    </div>
                  </div>
                  <b-collapse id="auto-comparative" accordion="evl-accordion" role="tabpanel">
                    <div class="row">
                      <div class="col-12">
                        <div class="card card-form">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-12" style="min-height: 500px">
                                <div class="table-wrapper">
                                  <table class="table table-bordered"
                                         v-if="autoData.kossApiResponseDto && autoData.kossApiResponseDto.autoDataApiList && autoData.kossApiResponseDto.autoDataApiList.length > 0">

                                    <tr>
                                      <td align="center" class="align-middle"><b><i>№</i></b></td>
                                      <td align="center" class="align-middle"><b><i>Кўрсаткичлар</i></b>
                                      </td>
                                      <td align="center" class="align-middle"><b><i>Тузатиш
                                        элементлари</i></b></td>
                                      <td align="center" class="align-middle"><b><i>Баҳолаш объекти</i></b>
                                      </td>
                                      <td colspan="3" align="center"><b><i>Такослаш объекти (аналоги)</i></b></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center"><b><i>I. Бўлим: Бозорни тадкик килиш, аналог
                                        обектлар бўйича ахборотни тахлил килиш ва йиғиш</i></b></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center"><b><i>1,1 Аналог объектларга доир битимлар
                                        (таклифлар) тўғрисида ахборот олиш максадида тадкик килиш.</i></b></td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,1</i></b></td>
                                      <td align="center"><b><i>Аналоглар</i></b></td>
                                      <td></td>
                                      <td></td>
                                      <td align="center"><b><i>Анолог 1</i></b></td>
                                      <td align="center"><b><i>Анолог 2</i></b></td>
                                      <td align="center"><b><i>Анолог 3</i></b></td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,2</i></b></td>
                                      <td align="center"><b><i>Русуми</i></b></td>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        {{ autoData.name }}
                                      </td>
                                      <td align="center" class="align-middle font-weight-bold" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,3</i></b></td>
                                      <td align="center" class="font-weight-bold">Позицияси</td>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        {{ autoData.autoTypeDto && autoData.autoTypeDto.position ? autoData.autoTypeDto.position:''}}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].position }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,4</i></b></td>
                                      <td align="center" class="font-weight-bold">Ишлаб чиқарилган йили</td>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        {{ autoData.madeYear }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{ autoData.kossApiResponseDto.autoDataApiList[n - 1].productionYear }}</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="2"
                                          class="align-middle font-weight-bold"><b><i>1,1,5</i></b>
                                      </td>
                                      <td align="center" rowspan="2"
                                          class="align-middle font-weight-bold">Маълумотлар баъзасида
                                        сакланаган ва Фойдаланилган манба
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].foreignCar
                                              ? "Хорижий" : "Махалий"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].source }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,6</i></b></td>
                                      <td align="center" class="font-weight-bold">Маълумотлар баъзасидаги
                                        Манбанинг эълон рақами ва хаволаси
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].link }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,7</i></b></td>
                                      <td align="center" class="font-weight-bold">Сотишга таклиф қилинган ёки
                                        сотилган сана
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].sourceDate }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            1,2 Аналог объектларга доир битимлар (таклифлар) тўғрисида
                                            ахборот олиш максадида тахлил килиш.
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" class="align-middle"><b><i>1,2,1</i></b></td>
                                      <td align="center" class="font-weight-bold">Сотишга таклиф қилинган ёки
                                        сотилган санадаги АҚШ долларини ўзбек сўмига нисбатан курси Марказий
                                        банк эълон ставкасида
                                      </td>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        <b>{{
                                            autoData.kossApiResponseDto.usdRate | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                      <td align="center" class="align-middle"
                                          v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].usdRate | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,2,2</i></b></td>
                                      <td align="center" class="font-weight-bold">
                                        Сотишга таклиф қилинган ёки сотилган санага нисбатан, Сотилиш баҳоси.
                                        АҚШ долларида
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" class="align-middle"
                                          v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].usdPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          $</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,2,3</i></b></td>
                                      <td align="center" class="font-weight-bold">Сотишга таклиф қилинган ёки
                                        сотилган санага нисбатан Сотилиш бахоси.
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].uzsPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="2" class="align-middle">
                                        <b><i>1,2,4</i></b></td>
                                      <td align="center" rowspan="2" class="align-middle font-weight-bold">Шартномавий
                                        нархи
                                      </td>
                                      <td align="center">Транспорт харажати</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].transportation.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Шартномавий нархи</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].transportation.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="6" class="align-middle">
                                        <b><i>1,2,5</i></b></td>
                                      <td align="center" rowspan="5" class="align-middle font-weight-bold">Импорт
                                        килишда
                                        соликлар ва йигимлар
                                      </td>
                                      <td align="center">Божхона божи</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.customs }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Акциз</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.excise }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">ҚҚС</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.vat }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Божхона харажатлари</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.customsClearance }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.taxCoefficient }}
                                        %
                                      </td>
                                    </tr>
                                    <tr align="center" class="align-middle">
                                      <td><b><i>Таклиф ёки сотилиш нархи</i></b></td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.taxFixPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2-Бўлим:Киёслаш бирликларини аниклаш
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,1 Техник тавсифлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,1</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">Унумдорлиги
                                        ёки
                                        куввати (Двигател ҳажмига тузатиш)
                                      </td>
                                      <td align="center">Дивигател хажми</td>
                                      <td rowspan="3" align="center" class="align-middle">
                                        {{ autoData.autoTypeDto &&
                                        autoData.autoTypeDto.engineCapacity ?
                                        autoData.autoTypeDto.engineCapacity:''}}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.value }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,2</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Юк кўтариши
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,3</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Юк тортиши
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,4</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Иш макони хажимлари
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,5</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Аниклик тоифаси
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,6</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Автоматлаштириш даражаси
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,2 Фойдаланиш тавсифлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>2,2,1</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Автоматик, ярим автоматик, ёки ноавтаматик фойдаланилиши
                                      </td>
                                      <td></td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.gearBoxFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <!--<td align="center"></td>-->
                                      <!--<td align="center">-->
                                      <!--{{autoData.kossApiResponseDto.gearBoxFix.coefficient | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                      <!--</td>-->
                                      <!--<td align="center" v-for="n in 3" :key="n">-->
                                      <!--{{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.value |-->
                                      <!--currency('', 2, { thousandsSeparator: ' ' })}}-->
                                      <!--</td>-->
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,2 Фойдаланиш тавсифлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        <!--{{autoData.kossApiResponseDto.gearBoxFix.coefficient | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.coefficient | currency('', 2, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,2,2</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Тўхтовсиз ишлаши
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,2,3</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Чидамлилиги
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,2,4</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Таъмирга яроклилиги
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Ярокли
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,2,5</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Бут сакланганлиги
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Бут сакланган
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,3 Конструктив тавсифлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,3,1</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Массаси
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>2,3,2</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Оғирлиги (Кг)
                                      </td>
                                      <td align="center">Ўлчов бирлиги</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Килограм
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Оғирлиги</td>
                                      <td align="center">{{ autoData.fullWeight }}</td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].weightFix.value }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].weightFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].weightFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>2,3,3</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Асосий конструктив материалларнинг таркиби
                                      </td>
                                      <td align="center">Позицияси</td>


                                      <td align="center" v-if="autoData.kossApiResponseDto.carPosition>0">
                                        {{ autoData.kossApiResponseDto.carPosition }}
                                      </td>
                                      <td align="center" v-if="autoData.kossApiResponseDto.carPosition==0">
                                        Мавжуд эмас
                                      </td>

                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Диллерлар томониданталиф килинаётган нарх
                                      </td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.newPriceUzs }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.value }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,4 Иқтисодий тавсифлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>2,4,1</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Машиналар вакт бирлигида
                                      </td>
                                      <td align="center">Ишлаб чикарилган йили</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.madeYearFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix && autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.name
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">
                                        Махсулот нархлари киматлашишнинг Статистик индекс
                                      </td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.madeYearFix.value }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.value }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b v-if="autoData.fixByIndex"><i>2,4,2</i></b>
                                        <b v-else><i>2,4,1</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Махсулот ёки ишлар бирлигида фаолият кўрсатганда турли захиралар
                                        сарфланиши
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b v-if="autoData.fixByIndex">{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                        <b v-else>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3-Боб Киёслаш элементларини танлаш.
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,1 Мулкий ҳуқуқлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,1,1</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Сотилганда ўтадиган мулкий ҳуқуқлар
                                      </td>
                                      <td></td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.ownershipFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].ownershipFix.name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.ownershipFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].ownershipFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].ownershipFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,2 Молиялаштириш шартлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>3,2,1</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Молиялаштириш шартлари
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Тўлов тури
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Олдиндан тўлов
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        <!--{{autoData.kossApiResponseDto.financeFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}-->
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].financeFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].financeFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td v-if="autoData.fixByIndex" colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,3 Бозор холати (Сотиш вакти)
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>3,3,1</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Аналог объектларга нархларнинг ўзгариши
                                      </td>
                                      <td align="center">Сотишга таклиф қилинган ёки сотилган сана</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.saleDateFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.name }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">
                                        Махсулот нархлари киматлашишнинг Статистик индекс
                                      </td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.saleDateFix.value }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.value }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.saleDateFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>


                                    <tr v-if="!autoData.fixByIndex">
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,3 Бозор холати (Сотиш вакти)
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr v-if="!autoData.fixByIndex">
                                      <td align="center" rowspan="4" style="vertical-align: middle;">
                                        <b><i>3,3,1</i></b></td>
                                      <td align="center" rowspan="4"
                                          style="vertical-align: middle; font-weight: bold">
                                        Аналог объектларга нархларнинг ўзгариши
                                      </td>
                                      <td align="center">Сотишга таклиф қилинган ёки сотилган сана</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.saleDateFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.name
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="!autoData.fixByIndex">
                                      <td align="center">
                                        Махсулот нархлари киматлашишнинг Статистик индекс
                                      </td>
                                      <td align="center" style="vertical-align: middle;font-weight: bold">
                                        {{
                                          autoData.kossApiResponseDto.usdRate | currency('', 2, {thousandsSeparator: ' '})
                                        }}
                                        сўм
                                      </td>
                                      <td align="center" style="vertical-align: middle" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.value | currency('', 2, {thousandsSeparator: ' '})
                                        }}
                                        сўм
                                      </td>
                                    </tr>
                                    <tr v-if="!autoData.fixByIndex">
                                      <td align="center">Тузатиш</td>
                                      <td align="center"></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="!autoData.fixByIndex">
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,4 Сотиш шартлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="19" class="align-middle">
                                        <b><i>3,4,1</i></b></td>
                                      <td align="center" rowspan="19" class="align-middle font-weight-bold">
                                        Сотувчи ва харидор ўртасидаги бозорга хос бўлмаган муносабатлар
                                      </td>
                                      <td align="center">Етказиб бершнинг тезлаштирилган муддати</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b v-if="autoData.fixByIndex">{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                        <b v-else>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Кафолат муддати (йилда)</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b v-if="autoData.fixByIndex">{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                        <b v-else>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b>Чегирмалар</b></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.name
                                          }}</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" class="align-middle"><b>Бутлаш</b></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" class="align-middle"><b>Қўшимча хизматлар</b>
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="2" class="align-middle"><b>ҚҚС
                                        мавжудлиги</b></td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.vatFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        Мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.vatFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].vatFix.value | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].vatFix.coefficientFix | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].vatFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,5 Физик тавсифлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>3,5,1</i></b>
                                      </td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Техник холати (Эскириш фоизи)
                                      </td>
                                      <td align="center">Холати</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.conditionFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.name ? autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.name : ''
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Эскириш фоизи
                                      </td>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.conditionFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.value | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.conditionFix.value }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,5,2</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>Жорий фойдаланиш хусусияти</i></b>
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,5,3</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>Қўшимча бутланиш</i></b>
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,6 Фойдаланиш шартлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,6,1</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>Жорий фойдаланиш хусусияти</i></b>
                                      </td>
                                      <td align="center">Ёкилғи тури</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.fuelTypeFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.fuelTypeFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,6,2</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>Функцианал фойдаланиш</i></b>
                                      </td>
                                      <td align="center"></td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.autoType }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].autoType }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        1
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        Тузатишлар сони
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].totalComparativeFix.fixedCount
                                          }}</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        Коффициент улушлари
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].totalComparativeFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                          }}</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        Тузатишларни киритгандан кейинги улушларни хисобга олгандаги бахоси
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].totalComparativeFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.auto-cost v-tooltip="'Харажат ёндашув'">
                      <h4>
                        <div class="d-flex">
                          <i class="fa fa-arrow-down"></i>
                          <input type="checkbox" class="ml-2 mr-1"
                                 v-model="auto.appraisalAutoDto.approachOne">
                          {{ $t("auto.approach.expense") }}
                          <b class="ml-4" v-if="auto.appraisalAutoDto.approachOne">
                            <span class="text-success"
                                  v-if="autoData.totalGovPrice">{{
                                autoData.totalGovPrice | currency('', 0, {thousandsSeparator: ' '})
                              }} сўм</span>
                          </b>
                        </div>
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="auto-cost" accordion="evl-accordion" role="tabpanel">
                    <div class="row">
                      <div class="col-12 table-responsive">
                        <div class="card">
                          <div class="table-wrapper">
                            <table class="table">
                              <tbody>
                              <tr>
                                <td class="text-center">
                                  Ишлаб чиқарилган йили
                                </td>
                                <td class="text-center">
                                  {{ autoData.madeYear }}
                                </td>
                              </tr>
                              <tr>
                                <td class="text-center">
                                  Босиб ўтган йўли
                                </td>
                                <td class="text-center">
                                  {{ autoData.overpassKm }} км
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Бохаланаётган машина тўла вазни
                                </td>
                                <td class="text-center">
                                  {{ autoData.fullWeight }} кг
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Турдош машинанинг номи
                                </td>
                                <td class="text-center">
                                  {{ autoData.coincidentalAutoDto.coincidentalName }}
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Турдош машина тўла вазни
                                </td>
                                <td class="text-center">
                                  {{ autoData.coincidentalAutoDto.fullWeight }} кг
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Чегирма лимити қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.discountLimit }} USD
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  НДС қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.vat }}
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Божхона ставкаси қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.customs }}
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Йўл харажатлари қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.road }}
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Божхона хужжатларини расмийлаштириш харажатлари қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.customsClearance }}
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Акциз солиқ қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.excise }}
                                </td>
                              </tr>
                              <tr v-if="autoData.priceInCurrency">
                                <td class="text-center">
                                  Валютадаги суммаси
                                </td>
                                <td class="text-center">
                                  {{ autoData.priceInCurrency | currency('', 2, {thousandsSeparator: ' '}) }}
                                  {{ autoData.currency }}
                                </td>
                              </tr>
                              <tr v-if="autoData.priceInCurrency">
                                <td class="text-center">
                                  Валюта курси
                                </td>
                                <td class="text-center">
                                  {{ autoData.currencyRate | currency('', 2, {thousandsSeparator: ' '}) }}
                                  {{ autoData.currency }}
                                </td>
                              </tr>
                              <tr v-if="!autoData.coincidental">
                                <td class="text-center">
                                  Машинанинг тикланиш қийматини суммаси
                                </td>
                                <td class="text-center" v-if="autoData.govPrice>0">
                                  {{ autoData.govPrice | currency('', 2, {thousandsSeparator: ' '}) }} Сум
                                </td>
                                <td class="text-center" v-else>
                                  {{ 0 | currency('', 2, {thousandsSeparator: ' '}) }} Сум
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Турдош машинанинг тикланиш қийматини суммаси
                                </td>
                                <td class="text-center">
                                  {{
                                    autoData.coincidentalAutoDto.coincidentalPrice | currency('', 2, {
                                      thousandsSeparator: ' '
                                    })
                                  }} Сум
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Қўшимча қиймат солиги
                                </td>
                                <td class="text-center">
                                  {{
                                    autoData.coincidentalAutoDto.nds_tax | currency('', 2, {
                                      thousandsSeparator: ' '
                                    })
                                  }}
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Фойда солиги ставкаси
                                </td>
                                <td class="text-center">
                                  {{
                                    autoData.coincidentalAutoDto.npr_tax | currency('', 2, {
                                      thousandsSeparator: ' '
                                    })
                                  }}
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Махсулотнинг рентабиллик курсаткичи
                                </td>
                                <td class="text-center">
                                  {{
                                    autoData.coincidentalAutoDto.profitabilityRatio | currency('', 2, {
                                      thousandsSeparator: ' '
                                    })
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td class="text-center">
                                  Машинанинг эскириш қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.dilapidationValue | currency('', 2, {thousandsSeparator: ' '}) }} %
                                </td>
                              </tr>

                              </tbody>
                            </table>
                          </div>

                        </div>
                        <h4 class="card-title text-center"><b>Автотранспортга ўрнатилган газ ускунаси</b></h4>
                        <div class="card">
                          <div class="table-wrapper">
                            <table class="table">
                              <thead>
                              <tr>
                                <th>Қурилма номи</th>
                                <th>Сиғими</th>
                                <th>Сони</th>
                                <th>Фойдаланилган веб-сайт</th>
                                <th>Бахоси (сўм)</th>
                                <th>Эскириш қиймати</th>
                                <th>Қиймати</th>
                              </tr>
                              </thead>
                              <tbody v-if="autoData.autoGasDevice">
                              <tr>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.name }}
                                </td>
                                <td>
                                  {{ autoData.autoGasDevice.capacity || '' }} л
                                </td>
                                <td>
                                  {{ autoData.autoGasDevice.qty || '' }} дона
                                </td>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.webSite }}
                                </td>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.price | currency('', 2, {thousandsSeparator: ' '}) }}
                                </td>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.dilapidationValue }} %
                                </td>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.totalPrice | currency('', 2, {thousandsSeparator: ' '}) }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>

              <!--<div class="row">-->
              <!--<div class="col-12">-->
              <!--<div class="section-header font-weight-bold colllapse-header">-->
              <!--<div block v-b-toggle.auto-income v-tooltip="'Даромад'">-->
              <!--<h4>-->
              <!--<div class="d-flex">-->
              <!--<i class="fa fa-arrow-down"></i>-->
              <!--<input type="checkbox" class="ml-2 mr-1"-->
              <!--v-model="autoData.approachTwo">-->
              <!--{{ $t("auto.approach.income") }}-->
              <!--<b class="ml-4" v-if="autoData.approachTwo">-->
              <!--<span class="text-success"></span>-->
              <!--</b>-->
              <!--</div>-->
              <!--</h4>-->
              <!--</div>-->
              <!--</div>-->
              <!--<b-collapse id="auto-income" accordion="evl-accordion" role="tabpanel">-->
              <!--<div class="row">-->

              <!--</div>-->
              <!--</b-collapse>-->
              <!--</div>-->
              <!--</div>-->

              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.auto-correction v-tooltip="'Мувофиклаштириш'">
                      <h4>
                        <i class="fa fa-arrow-down"></i>
                        Мувофиклаштириш
                        <b class="ml-4" v-if="autoData.evlPrice">
                          <span
                              class="text-success">{{ autoData.evlPrice | currency('', 0, {thousandsSeparator: ' '}) }} сўм</span>
                        </b>
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="auto-correction" accordion="evl-accordion" role="tabpanel">
                    <div class="row">
                      <div class="col-12 table-responsive">
                        <div class="card">
                          <div class="table-wrapper">
                            <table class="table">
                              <tr>
                                <th class="text-center">Омиллар</th>
                                <th class="text-center" width="20%">Харажат ёндашуви %</th>
                                <th class="text-center" width="20%">Киёсий ёндашуви %</th>
                                <!--<th class="text-center" width="20%">Киёсий ёндашуви %</th>-->
                              </tr>
                              <tr>
                                <td>
                                  <b>Ҳисоблаб топилган кийматлар, Сум</b>
                                </td>
                                <td align="center">
                                  <b>{{ autoData.totalGovPrice | currency('', 0, {thousandsSeparator: ' '}) }} сўм </b>
                                </td>
                                <td align="center">
                                  <b>{{ autoData.avgPrice | currency('', 0, {thousandsSeparator: ' '}) }} сўм </b>
                                </td>
                                <!--<td align="center">-->
                                <!--<b>{{autoData.avgPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм </b>-->
                                <!--</td>-->
                              </tr>
                              <tr v-for="(correctionType, index) in autoData.correctionTypeDtos"
                                  :key="correctionType.id">
                                <td>
                                  {{ correctionTypeEnum[index][correctionType.correctionType] }}
                                </td>
                                <td class="text-center">
                                                                    <span
                                                                        v-if="correctionType.key!=='SpecificDimensionsApproaches'">
                                                                        {{
                                                                        (correctionType.approachOnePercent / 6).toFixed(2)
                                                                      }} %
                                                                    </span>
                                  <span v-if="correctionType.key==='SpecificDimensionsApproaches'">
                                                                        <b>{{ calculated.totalOne }} %</b>
                                                                    </span>
                                </td>
                                <td class="text-center">
                                                                    <span
                                                                        v-if="correctionType.key!=='SpecificDimensionsApproaches'">
                                                                        {{
                                                                        (correctionType.approachThirdPercent / 6).toFixed(2)
                                                                      }} %
                                                                    </span>
                                  <span v-if="correctionType.key==='SpecificDimensionsApproaches'">
                                                                        <b>{{ calculated.totalThree }} %</b>
                                                                    </span>
                                </td>
                              </tr>
                              <tr v-if="autoData.correctionTypeDtos.length > 0">
                                <td>
                                  <b>Салмоқ бўйича қийматлар суммаси</b>
                                </td>
                                <td align="center">
                                  <b>{{ calculated.totalPriceOne | currency('', 0, {thousandsSeparator: ' '}) }}
                                    сўм</b>
                                </td>
                                <td align="center">
                                  <b>{{ calculated.totalPriceThree | currency('', 0, {thousandsSeparator: ' '}) }}
                                    сўм</b>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Аниқланган қиймати</b>
                                </td>
                                <td align="center" colspan="2">
                                  <b>{{ autoData.evlPrice | currency('', 0, {thousandsSeparator: ' '}) }} сўм </b>
                                </td>
                              </tr>
                            </table>
                          </div>

                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 mt-2">
                <div class="form-group">
                  <fitment-status-view :fitment="auto" v-if="auto.id"/>
                </div>
              </div>
              <div class="col-12 col-md-6 mt-2">
                <div class="form-group">
                  <fitment-history-view v-if="auto.id"/>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12 btns-box">
                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                  {{ $t("action.cancel") }}
                </button>
                <button class="all-btn add-btn" v-if="canSave" @click="save" :disabled="processing">
                  {{ $t("action.save") }}
                </button>
                <button class="all-btn" @click="changeStatus('Rated')" :disabled="processing" v-if="canEvaluate">
                  {{ $t("realEstate.action.evaluate") }}
                </button>
                <button class="all-btn add-btn" @click="changeStatus('Confirmed')" :disabled="processing"
                        v-if="canConfirm && (auto.appraiserReportEsp || !auto.hasEsp)">
                  {{ $t("realEstate.action.confirm") }}
                </button>
                <button class="all-btn add-btn" @click="sendEvaluationObjectToIdentification(auto)" :disabled="processing"
                        v-if="canInIdentification">
                  Идентификацияга бериш
                </button>
                <button class="all-btn" @click="openSignPageAppraiser(auto)" :disabled="processing"
                        v-if="canConfirm && auto.hasEsp && !auto.appraiserReportEsp">
                  Баҳоловчи тасдиқлаш (ЭЦП)
                </button>
                <button class="all-btn add-btn" @click="openSignPageDirector(auto)"
                        :disabled="processing"
                        v-if="hasPermission('NEW_AUTO_CONFIRM') && auto.appraisalStatusEnum === 'Confirmed' && auto.hasEsp && auto.appraiserReportEsp && !auto.directorReportEsp">
                  Директор тасдиқлаш (ЭЦП)
                </button>
                <button class="all-btn edit-btn" @click="changeStatus('Unreviewed')"
                        :disabled="processing" v-if="canReEvaluate">
                  {{ $t("realEstate.action.reevaluate") }}
                </button>
                <button class="all-btn delete-btn" @click="deleteAuto(auto)"
                        v-if="hasPermission('NEW_AUTO_DELETE')">
                  {{ $t("realEstate.delete.title") }}
                </button>

                <button class="all-btn delete-btn" v-if="canReject" @click="rejectOrder">
                  <i class="fa fa-reply-all"></i>
                  <span>Рад қилиш</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RejectComment/>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
// import {numericTypes} from '@/shared/constants/mask'
import initFilterModel from '@/shared/filter';
import AssetDropZone from '@/views/asset/AssetDropZone'
import {required, requiredUnless} from 'vuelidate/lib/validators';
// import {required, minLength, maxLength} from 'vuelidate/lib/validators';
import {parseDate, formatDate} from '@/shared/utils';
import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
import FitmentStatusView from '@/views/fitment/FitmentStatusView.vue'
import FitmentHistoryView from '@/views/fitment/FitmentHistoryView.vue'
import RejectComment from '@/components/RejectComment';
import InnerImageZoom from 'vue-inner-image-zoom';
import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
import {BFormRadioGroup} from 'bootstrap-vue/es/components/form-radio/form-radio-group'
import {BFormGroup} from 'bootstrap-vue/es/components/form-group/form-group'
import {
  AUTO_PART_CONDITIONS,
  AUTO_SALON_PART_CONDITIONS,
  TECHNICAL_CONDITIONS,
  EXIST_NOT_EXIST,
  CORRECTION_TYPE_ENUM
} from '@/shared/constants/auto'
import {mapState} from "vuex";

export default {
  name: "auto-plus-add-edit",
  components: {
    AssetDropZone,
    Datepicker,
    PreviewDropZone,
    FitmentStatusView,
    FitmentHistoryView,
    RejectComment,
    BCollapse,
    BFormGroup,
    BFormRadioGroup,
    InnerImageZoom
  },
  directives: {
    'b-toggle': VBToggle
  },
  data() {
    return {
      processing: false,
      loading: {
        isDocQrLoading: false,
        isDocLoading: false,
        isPdfLoading: false,
        isPdfQrLoading: false,
        isCDocLoading: false,
        isCPdfLoading: false,
        isCDocQrLoading: false,
        isCPdfQrLoading: false,
        isDocNotSignedAndQRCodeLoading: false,
        isPdfNotSignedAndQRCodeLoading: false
      },
      oldEvaluationWorks: null,
      autoInformationVisible: false,
      isPageLoadInit: false,
      show: false,
      ownerFilter: initFilterModel(),
      customerFilter: initFilterModel(),
      autoTypeFilter: initFilterModel(),
      employeeFilter: initFilterModel(),
      technicalConditionOfCars: [],
      dilapidationLookupData: [],
      autoAllPhotos: [],
      texPassportAllPhotos: [],
      autoTypeDtos: [],
      fuelTypes: [],
      selectedRealEstateDocsTab: "images",
      prev: '<i class="material-icons">keyboard_arrow_left</i>',
      next: '<i class="material-icons">keyboard_arrow_right</i>',
      autoPartConditions: AUTO_PART_CONDITIONS,
      evlAutoSaloonPartConditions: AUTO_SALON_PART_CONDITIONS,
      technicalConditions: TECHNICAL_CONDITIONS,
      additionalConveniences: EXIST_NOT_EXIST,
      correctionTypeEnum: CORRECTION_TYPE_ENUM,
      employees: [],
      owners: [],
      customers: [],
      autoData: {
        autoGasDevice: {},
        correctionTypeDtos: []
      },
      auto: {
        hasCustomerClient: false,
        powerOfAttorneyNumber: null,
        appraisalAutoDto: {}
      },
      powerOfAttorneyDate: null
    }
  },
  validations() {
    return {
      auto: {
        // evaluatorOpinion: {
        //     required: required
        // },
        ownerClient: {
          required: required
        },
        powerOfAttorneyNumber: {
          required: required
        },
        customerClient: {
          required: requiredUnless(() => {
            return !(this.auto.hasCustomerClient);
          })
        },
        employee: {
          required: required
        },
        appraisalAutoDto: {
          autoTypeDto: {
            required: required
          },
          madeYear: {
            required: required
          },
          governmentNum: {
            required: required
          },
          technicalConditionOfCar: {
            required: required
          },
          dilapidationValueByExpert: {
            required: required
          },
          texPassportNum: {
            required: required
          },
          address: {
            required: required
          },
          overpassKm: {
            required: requiredUnless(() => {
              if (this.auto.appraisalAutoDto.autoTypeDto.typeOfCar === 'SpecialMachinery'
                      || this.auto.appraisalAutoDto.autoTypeDto.typeOfCar === 'HalfTrailers'
                      || this.auto.appraisalAutoDto.autoTypeDto.typeOfCar === 'Trailers') {
                return true;
              } else {
                return false;
              }
            })
          },
          fuelType: {
            required: requiredUnless(() => {
              if (this.auto.appraisalAutoDto.autoTypeDto.typeOfCar === 'HalfTrailers'
                      || this.auto.appraisalAutoDto.autoTypeDto.typeOfCar === 'Trailers') {
                return true;
              } else {
                return false;
              }
            })
          },
          // texPassportFiles: {
          //     required: required,
          //     minLength: minLength(1),
          //     maxLength: maxLength(2)
          // },
          // autoPhotos: {
          //     required: required,
          //     minLength: minLength(1)
          // }
        }
      },
      powerOfAttorneyDate: {
        required: requiredUnless(() => {
          return !(this.auto.hasCustomerClient);
        })
      }
    };
  },
  computed: {
    ...mapState(['profile']),
    calculated() {
      let differenceOfApproach;
      if (this.autoData.totalGovPrice < this.autoData.avgPrice)
        differenceOfApproach = (1 - (this.autoData.totalGovPrice / this.autoData.avgPrice)).toFixed(4);
      else
        differenceOfApproach = (1 - (this.autoData.avgPrice / this.autoData.totalGovPrice)).toFixed(4);

      return {
        totalOne: differenceOfApproach > 0.3 ? 0.28 : (this.autoData.correctionTypeDtos[6].approachOnePercent / 6).toFixed(2),
        totalThree: differenceOfApproach > 0.3 ? 0.72 : (this.autoData.correctionTypeDtos[6].approachThirdPercent / 6).toFixed(2),
        totalPriceOne: (this.autoData.totalGovPrice * this.autoData.correctionTypeDtos[6].approachOnePercent / 6),
        totalPriceThree: (this.autoData.avgPrice * this.autoData.correctionTypeDtos[6].approachThirdPercent / 6)
      }
    },
    isLoses() {
      return this.auto.evlGoalType === "Losses";
    },
    showReportButton() {
      return (this.auto.appraisalStatusEnum === 'Rated' || this.auto.appraisalStatusEnum === 'Confirmed') && this.auto.id && this.auto.id > 0;
    },
    canSave() {
      return (!this.auto.appraisalStatusEnum || this.auto.appraisalStatusEnum === 'Unreviewed' || this.auto.appraisalStatusEnum === 'NotFullyEvaluated' || this.auto.appraisalStatusEnum === 'SentToComplement');
    },
    canEvaluate() {
      return (this.auto.appraisalStatusEnum === 'Unreviewed');
    },
    canConfirm() {
      return this.auto.appraisalStatusEnum === 'Rated' && this.hasPermission('NEW_AUTO_CONFIRM');
    },
    canInIdentification() {
      return this.auto.appraisalStatusEnum === 'SentToComplement' && this.hasPermission('NEW_AUTO_EDIT') && this.hasPermission('FILL_DATA_AND_SEND_TO_IDENTIFICATION');
    },
    canReEvaluate() {
      return (this.auto.appraisalStatusEnum === 'Rated' || this.auto.appraisalStatusEnum === 'Confirmed') && this.hasPermission('NEW_AUTO_REEVALUATE');
    },
    canReject() {
      return (this.hasPermission('NEW_AUTO_EDIT') || this.isLoses
          && this.hasPermission('NEW_AUTO_LOSES_EDIT'))
          && (this.auto.appraisalStatusEnum === 'Unreviewed' || (this.auto.appraisalStatusEnum === 'NotFullyEvaluated' && this.isUserDirector))
          && !this.auto.hasAppraiserReportEsp;
    },
    hasNotMileage() {
      return this.auto.appraisalAutoDto.autoTypeDto && this.auto.appraisalAutoDto.autoTypeDto.typeOfCar !== 'SpecialMachinery' &&
          this.auto.appraisalAutoDto.autoTypeDto.typeOfCar !== 'HalfTrailers' &&
          this.auto.appraisalAutoDto.autoTypeDto.typeOfCar !== 'Trailers';
    },
    isUserDirector() {
      return this.profile && this.profile.username === 'shohrux';
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;

      const promises = [];

      if (id && id > 0) {
        vm.isPageLoadInit = true;
        promises.push(this.$http.get('auto/plus/' + id));

        Promise.all(promises).then(function (values) {
          if (values.length >= 0) {
            const editData = values[0].data;
            if (!editData.evlGoalType) {
              editData.evlGoalType = '';
            }
            vm.contractDate = parseDate(editData.contractDate);
            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
            vm.tenderContractDate = parseDate(editData.tenderContractDate);
            vm.auto = editData;
            vm.auto.employee = {};
            if (editData.employeeId && editData.employeeName) {
              vm.auto.employee.id = editData.employeeId;
              vm.auto.employee.text = editData.employeeName;
            }
            if (editData.appraisalAutoDto) {
              vm.autoData = editData.appraisalAutoDto;
            }

            vm.auto.appraisalAutoDto.autoPhotos.forEach((file) => {
              vm.autoAllPhotos.push(file);
            });
            vm.auto.appraisalAutoDto.texPassportFiles.forEach((file) => {
              vm.texPassportAllPhotos.push(file);
            });

            vm.status = editData.appraisalStatusEnum;
            vm.isPageLoadInit = false;
            vm.onChangeTechnicalCondition();
            vm.searchOldEvalautionWork();
          }
        });
      }
    },
    searchOldEvalautionWork() {
      const autoevl = {
        search: this.auto.evaluationAutoDtoList[0].bodyNum,
        evlGoalType: this.auto.evlGoalType
      };
      this.$http.post('auto/old-evaluation-works', autoevl)
          .then(res => {
            if (res && res.data && res.data.status === 'SUCCESS') {
              this.oldEvaluationWorks = res.data;
            }
          }, err => {
            console.log(err);
          });
    },
    cancel() {
      this.$router.push('/auto/plus/list');
    },
    getTechnicalConditionsOfCar() {
      this.$http.get('/technicalConditionsOfCar').then(response => {
        this.technicalConditionOfCars = response.data;
      }, err => {
        console.log(err)
      });
    },
    onChangeTechnicalCondition() {
      this.dilapidationLookupData = [];
      if (this.auto != null && this.auto.appraisalAutoDto != null && this.auto.appraisalAutoDto.technicalConditionOfCar != null) {
        const vm = this;
        this.$http.get('/dilapidation-value-expert/' + this.auto.appraisalAutoDto.technicalConditionOfCar)
            .then(res => {
              vm.dilapidationLookupData = res.data;
            }, err => {
              console.log(err);
            });
      }
    },
    reportPdf: function (auto) {
      this.loading.isPdfLoading = true;
      this.downloadFile('/v2/autoReport/pdf/WITH_SIGNATURE/' + auto.hashUuid,
          'Хисобот ' + auto.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isPdfLoading');
    },
    notSignedAndQRCodeReportPdf: function (auto) {
      this.loading.isPdfNotSignedAndQRCodeLoading = true;
      this.downloadFile('/v2/autoReportNotSignedAndQRCode/pdf/WITH_SIGNATURE/' + auto.hashUuid,
          'Хисобот ' + auto.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isPdfNotSignedAndQRCodeLoading');
    },
    reportPdfQrCode: function (auto) {
      this.loading.isPdfQrLoading = true;
      this.downloadFile(`/v2/autoReport/pdf/WITH_QR_CODE/${auto.hashUuid}`,
          'Хисобот ' + auto.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isPdfQrLoading');

    },
    reportDoc: function (auto) {
      this.loading.isDocLoading = true;
      this.downloadFile('/v2/autoReport/doc/WITH_SIGNATURE/' + auto.hashUuid,
          'Хисобот ' + auto.ownerClient.fullName + '.doc',
          'application/doc',
          'isDocLoading');
    },
    notSignedAndQRCodeReportDoc: function (auto) {
      this.loading.isDocNotSignedAndQRCodeLoading = true;
      this.downloadFile('/v2/autoReportNotSignedAndQRCode/doc/WITH_SIGNATURE/' + auto.hashUuid,
          'Хисобот ' + auto.ownerClient.fullName + '.doc',
          'application/doc',
          'isDocNotSignedAndQRCodeLoading');
    },
    reportDocQrCode: function (auto) {
      this.loading.isDocQrLoading = true;
      this.downloadFile('/v2/autoReport/doc/WITH_QR_CODE/' + auto.hashUuid,
          'Хисобот ' + auto.ownerClient.fullName + '.doc',
          'application/doc',
          'isDocQrLoading');
    },
    downloadFile: function (url, name, type, loading) {
      console.log(url);
      this.$http.get(url, {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: type});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = name;
            link.click();
            this.loading[loading] = false;
          })
          .catch(err => {
            console.log(err);
            this.loading[loading] = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.downloadFile(url, name, type, loading))
            }
          })
    },
    contractDocQrCode: function (auto) {
      this.loading.isCDocQrLoading = true;
      this.downloadFile('/v2/autoContract/doc/' + auto.hashUuid + '/WITH_QR_CODE',
          'Шартнома ' + auto.ownerClient.fullName + '.doc',
          'application/doc',
          'isCDocQrLoading');
    },
    contractDoc: function (auto) {
      this.loading.isCDocLoading = true;
      this.downloadFile('/v2/autoContract/doc/' + auto.hashUuid + '/WITH_SIGNATURE',
          'Шартнома ' + auto.ownerClient.fullName + '.doc',
          'application/doc',
          'isCDocLoading');
    },
    contractPdf: function (auto) {
      this.loading.isCPdfLoading = true;
      this.downloadFile('/v2/autoContract/pdf/' + auto.hashUuid + '/WITH_SIGNATURE',
          'Шартнома ' + auto.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isCPdfLoading');
    },
    contractQrCodePdf: function (auto) {
      this.loading.isCPdfQrLoading = true;
      this.downloadFile('/v2/autoContract/pdf/' + auto.hashUuid + '/WITH_QR_CODE',
          'Шартнома ' + auto.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isCPdfQrLoading');
    },
    onAutoTypeSearch(searchTxt, loading) {
      loading(true);
      this.autoTypeFilter.search = searchTxt;
      this.searchMethod(loading);
    },
    onAutoTypeFocus() {
      this.autoTypeFilter.search = '';
      this.searchMethod();
    },
    searchMethod(loading) {
      this.autoTypeDtos = [];
      this.$http.post('autoType/searchBy', this.autoTypeFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.autoTypeDtos = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onChangeTechnicalConditionReport() {
      if (this.auto.appraisalAutoDto.technicalConditionReport === "Accessible") {
        this.auto.appraisalAutoDto.electricalComponents = "Accessible";
        this.auto.appraisalAutoDto.steeringMechanisms = "Accessible";
        this.auto.appraisalAutoDto.engine = "Accessible";
        this.auto.appraisalAutoDto.transmissionBox = "Accessible";
        this.auto.appraisalAutoDto.saloonParts = "Accessible";
      }
    },
    getAutoFuelType() {
      this.$http.get('/fuel-type-car').then(response => {
        this.fuelTypes = response.data;
      }, err => {
        console.log(err)
      });
    },
    saveAuto() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.processing = true;
      this.$http.post('auto/item/save', this.auto.appraisalAutoDto)
          .then(res => {
            this.processing = false;
            if (res.data.status !== 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t(res.data.message),
                type: 'warning'
              });
              return;
            }
            this.$swal({
              title: this.$t('messages.common.success'),
              text: this.$t('auto.success'),
              type: 'success'
            });
            this.auto.appraisalAutoDto.id = res.data.data;
            this.$router.push('/auto/plus/edit/' + this.auto.id);
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('auto.error'),
              type: 'error'
            });
            this.processing = false;
          });
    },
    save() {

      if (this.powerOfAttorneyDate) {
        this.auto.powerOfAttorneyDate = formatDate(this.powerOfAttorneyDate);
      }

      this.processing = true;
      this.$http.post('auto/save', this.auto)
          .then(res => {
            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.auto.statusSuccess'),
                type: 'success'
              });
              this.$router.push('/auto/plus/edit/' + res.data.data.id);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: res.data.message,
                type: 'warning'
              });
            }
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.auto.statusError'),
              type: 'error'
            });
            this.processing = false;
          });
    },

    changeStatus(status) {
      this.processing = true;
      this.isPageLoadInit = true;

      this.$http.get('contractRegion/check-contract/' + this.auto.id + "/Auto").then(response => {
        if (response.data.status !== 'SUCCESS' || response.data.status === 'SUCCESS' && response.data.code === 'ALLOWED') {
          this.$swal({
            title: this.$t('messages.common.warning'),
            text: response.data.message,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dd3333',
            confirmButtonText: 'Давом этиш',
            cancelButtonText: 'Бекор қилиш'
          }).then((result) => {
            if (result.value) {
              this.sendChangesToServer(status);
            }
            this.processing = false;
          });
        } else {
          this.sendChangesToServer(status);
        }
      });
    },
    sendChangesToServer(status) {
      this.$http.post('change/status', {
        id: this.auto.id,
        appraisalStatusEnum: status,
      }).then(res => {
        if (res && res.data) {
          if (res.data.status === 'SUCCESS') {
            this.$swal({
              title: this.$t('messages.common.success'),
              text: this.$t('messages.auto.statusSuccess'),
              type: 'success'
            });
            this.auto.appraisalStatusEnum = status;
            this.status = status;

            // console.log("status = ", status)
            if (status === 'Confirmed') {
              // console.log("status1 = ", status)
              // if (this.auto.hasEsp) {
              //   console.log("status2 = ", status)
                this.openSignPageDirector(this.auto);
              // }
            } else if (status === 'Rated') {
              // console.log("status11 = ", status)
              // console.log("this.auto = ", this.auto)
              // console.log("this.auto.hasEsp = ", this.auto.hasEsp)
              // if (this.auto.hasEsp !== true) {
              //   console.log("status22 = ", status)
                this.openSignPageAppraiser(this.auto);
              // }
            } else if (status === 'Unreviewed') {
              window.location.reload();
            }

          } else if (res.data.status === 'FAIL') {

            this.$swal({
              title: this.$t('messages.common.warning'),
              text: res.data.message,
              type: 'warning'
            });

          } else if (res.data.status === 'ERROR') {
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: res.data.message,
              type: 'warning'
            });
          }
        } else {
          this.$swal({
            title: this.$t('messages.common.warning'),
            text: this.$t('messages.auto.statusWarning'),
            type: 'warning'
          });
        }
        this.processing = false;
        this.isPageLoadInit = false;
      }, () => {
        this.$swal({
          title: this.$t('messages.common.error'),
          text: this.$t('messages.auto.statusError'),
          type: 'error'
        });
        this.processing = false;
        this.isPageLoadInit = false;
      });
    },
    openSignPageDirector: function (auto) {
      this.processing = true;
      this.$http.get('/esign/director/' + auto.id + '/Auto')
          .then(response => {
            if (response && response.status === 200) {
              window.open(response.data.data);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: response.data.message,
                type: 'warning'
              });
            }
            this.processing = false;
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: this.$t('messages.common.error'),
              type: 'warning'
            });
            this.processing = false;
          })
    },
    openSignPageAppraiser: function (auto) {

      this.processing = true;
      this.$http.get('/esign/appraiser/' + auto.id + '/Auto')
          .then(response => {
            if (response && response.status === 200) {
              window.open(response.data.data);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: response.data.message,
                type: 'warning'
              });
            }
            this.processing = false;
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: this.$t('messages.common.error'),
              type: 'warning'
            });
            this.processing = false;
          })
    },
    deleteAuto: function (auto) {
      this.processing = true;
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('auto.deleteConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
      }).then((result) => {
        if (result.value) {
          this.$http.delete('delete/appraisal/' + auto.id)
              .then((res) => {
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('auto.deleteSuccess'),
                    type: 'success'
                  });
                  this.cancel()
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('auto.deleteError'),
                  type: 'error'
                });
                this.processing = false;
              });
        } else {
          this.processing = false;
        }
      });
    },
    rejectOrder() {
      this.$eventBus.$emit('RejectComment', this.auto.id, this.isLoses, "Auto");
    },
    onEmployeeSearch(searchTxt, loading) {
      loading(true);
      this.employees = [];
      this.employeeFilter.search = searchTxt;
      this.$http.post('employes/search', this.employeeFilter)
          .then(res => {
            this.employees = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onEmployeeFocus() {
      this.employees = [];
      this.employeeFilter.search = '';
      this.$http.post('employes/search', this.employeeFilter)
          .then(res => {
            this.employees = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onChangeEmployee() {
      if (this.auto.employee) {
        this.auto.employeeId = this.auto.employee.id
      }
    },
    onOwnerSearch(searchTxt, loading) {
      loading(true);
      this.owners = [];
      this.ownerFilter.search = searchTxt;
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onOwnerFocus() {
      this.owners = [];
      this.ownerFilter.search = '';
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onCustomerSearch(searchTxt, loading) {
      loading(true);
      this.customers = [];
      this.customerFilter.search = searchTxt;
      this.$http.post('customer/search', this.customerFilter)
          .then(res => {
            this.customers = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onCustomerFocus() {
      this.customers = [];
      this.customerFilter.search = '';
      this.$http.post('customer/search', this.customerFilter)
          .then(res => {
            this.customers = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    sendEvaluationObjectToIdentification: function (auto) {
      this.processing = true;
      this.$http.get('/auto/send-evaluation-object-identification/' + auto.id)
          .then(response => {

            if (response && response.data && response.data.status === 'SUCCESS') {
              console.log("this.auto.id =", this.auto.id);
              window.location.reload();
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: response.data.message,
                type: 'warning'
              });
            }
            this.processing = false;
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: this.$t('messages.common.error'),
              type: 'warning'
            });
            this.processing = false;
          })
    }
  },
  created() {
    this.init();
    this.getTechnicalConditionsOfCar();
    this.getAutoFuelType();
  }
}
</script>

<style scoped>

</style>
